import template from './manage-signature.html';
import controller from './manage-signature.controller';

let ManageSignatureModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: 'hmodal-info animated fadeIn'
};

export default ManageSignatureModal;



// WEBPACK FOOTER //
// ./client/pages/profile/modals/manage-signature/manage-signature.component.js